import Axios from "axios";
import { handleError } from "../Functions/getAlert";
import {  erase } from "../Functions/cookieFunction";
import vendorsConfig from "../vendorsConfig";

export const getApplePayToken = async (
  payDAta,
  appState,
  setTapId,
  appDispatch,
  setPLoading,
  setAlertMessage,
  removeLocalStorage,
) => {
  const ApplePaySession = window.ApplePaySession;

  if (!ApplePaySession) {
    return;
  }
  console.log("getApplePayToken()");

  let data = payDAta;
  console.log(data.invoiceId);
  const request = {
    countryCode: "KW",
    currencyCode: "KWD",
    merchantCapabilities: ["supports3DS"],
    supportedNetworks: ["visa", "masterCard", "amex", "discover"],
    total: {
      label: "Pay with Apple Pay",
      type: "final",
      amount: data.invoiceDetails?.is_partial
      ? Number(data?.handleRemaningAmount()) <= 0.1 
        ? (Number(data?.splitBillAmount) + Number(data?.handleRemaningAmount())).toFixed(3) 
        : Number(data?.splitBillAmount).toFixed(3)
      : Number(data?.amount),
    
    },
  };

  console.log("request()", request);

  const session = new ApplePaySession(6, request);

  console.log(session, "session");

  session.onvalidatemerchant = async (event) => {
    let merchantBackendUrl = `${process.env.REACT_APP_API_URL}apple-pay/merchant-validation`;
    let appUrl = `${process.env.REACT_APP_PAY_DOMAIN}`;
    let body = {
      validation_url: event.validationURL,
      domain: appUrl,
    };
    fetch(merchantBackendUrl, {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((merchantSession) => {
        console.log("merchecnt", merchantSession);
        session.completeMerchantValidation(merchantSession);
      })
      .catch((error) => console.error(error)); // We need to handle the error instead of just logging it to console.
  }; // See "Providing Merchant Validation"
  session.onpaymentauthorized = async (event) => {
    const token = await event.payment.token;
    let tokenObj = await token.paymentData;

    if (data.type == "qp") {
      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}order_invoice/offline`,
          {
            country_code: "965",
            number: appState.loggedIn
              ? appState.profile.number
              : data.formData.number,
            name: appState.loggedIn
              ? appState.profile.userFirstName
              : data.customer.name
              ? data.customer.name
              : data.formData.name
              ? data.formData.name
              : `Customer${Date.now()}`,
            email:
              appState.loggedIn && appState.profile.email != null
                ? appState.profile.email
                : data.formData.email != undefined
                ? data.formData.email
                : null,
            store_slug: data.id,
            customer_id: appState.loggedIn ? appState.profile.userId : "",
            amount: data.amount,
            payment_source: "apple_pay",
            token: null,
            apple_pay_token: token.paymentData,
            save_card: false,
          }
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
          localStorage.removeItem("formData");
          localStorage.removeItem("fields");
          setTapId(null);
          session.completePayment({
            status: ApplePaySession.STATUS_SUCCESS,
          });
        } else if (response.data.success == false) {
          setAlertMessage({
            open: true,
            message: `${response.data.message}: ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });

          setPLoading(false);
          session.completePayment({
            status: ApplePaySession.STATUS_FAILURE,
          });
        }
      } catch (e) {
        handleError(e, appDispatch);
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
        session.completePayment({
          status: ApplePaySession.STATUS_FAILURE,
        });
      }
    } else if (data.type == "in" && !data.invoiceDetails?.is_partial) {
  

      try {
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}order_invoice/pay`,
          {
            country_code: "965",
            number: appState.loggedIn
              ? appState.profile.number
              : data.formData.number,
            name: appState.loggedIn
              ? appState.profile.userFirstName
              : data.customer.name
              ? data.customer.name
              : data.formData.name
              ? data.formData.name
              : `Customer${Date.now()}`,
            email:
              appState.loggedIn && appState.profile.email != null
                ? appState.profile.email
                : data.formData.email != undefined
                ? data.formData.email
                : null,
            invoice_id: data.id,
            amount: data.amount,
            payment_source: "apple_pay",
            apple_pay_token: token.paymentData,
            card_id: null,
            customer_id: appState.loggedIn ? appState.profile.userId : "",
            save_card: false,
          }
        );
        if (response.data.success == true) {
          const win = window.open(`${response.data.data.url}`, "_self");
          win.focus();
          localStorage.removeItem("formData");
          localStorage.removeItem("fields");
          setTapId(null);
          session.completePayment({
            status: ApplePaySession.STATUS_SUCCESS,
          });
          return;
        } else if (response.data.success == false) {
          console.log("response.data.success == false");
          setAlertMessage({
            open: true,
            message: `${response.data.message}: ${response.data.data}`,
            alertSuccess: false,
          });
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          session.completePayment({
            status: ApplePaySession.STATUS_FAILURE,
          });
        }
      } catch (e) {
        erase("tokenAuth");
            erase("Profile");
            appDispatch({ type: "logout" });
        handleError(e, appDispatch);
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
        session.completePayment({
          status: ApplePaySession.STATUS_FAILURE,
        });
      }
    } else if (data.type == "in" && data.invoiceDetails?.is_partial) {
      if (data.splitBillAmount <= data.amount) {
        console.log("last");
        try {
          const response = await Axios.post(
            `${process.env.REACT_APP_API_URL}partial_invoice/pay`,
            {
              country_code: "965",
              number: appState.loggedIn
                ? appState.profile.number
                : data.formData.number,
              name: appState.loggedIn
                ? appState.profile.userFirstName
                : data.customer.name
                ? data.customer.name
                : data.formData.name
                ? data.formData.name
                : `Customer${Date.now()}`,
              email:
                appState.loggedIn && appState.profile.email != null
                  ? appState.profile.email
                  : data.formData.email != undefined
                  ? data.formData.email
                  : null,
              customer_id: appState.loggedIn ? appState.profile.userId : "",
              save_card: false,
              invoice_id: data.id,
              amount: Number(data?.handleRemaningAmount()) <= 0.1 
              ? (Number(data?.splitBillAmount) + Number(data?.handleRemaningAmount())).toFixed(3) 
              : Number(data?.splitBillAmount).toFixed(3),            
              payment_source: "apple_pay",
              token: null,
              type: data.partialType,
              apple_pay_token: token.paymentData,
              meta: {
                data:
                  data.partialType == "ratio"
                    ? {
                        person: data.totalPerson,
                        payer: data.personWillPay,
                      }
                    : data.partialType == "product"
                    ? data.paySelectedItems
                    : null,
                partial_type: data.partialType,
              },
            }
          );
          if (response.data.success == true) {
            console.log("response.data.success == true with partial");

            const win = window.open(`${response.data.data.url}`, "_self");
            win.focus();
            localStorage.removeItem("formData");
            localStorage.removeItem("fields");
            setTapId(null);
            removeLocalStorage();
            session.completePayment({
              status: ApplePaySession.STATUS_SUCCESS,
            });
            return;
          } else if (response.data.success == false) {
            console.log("response.data.success == false with partial");

            setAlertMessage({
              open: true,
              message: `${response.data.message}: ${response.data.data}`,
              alertSuccess: false,
            });
            appDispatch({
              type: "Set_FreezScreen",
              freezScreen: false,
            });
            session.completePayment({
              status: ApplePaySession.STATUS_FAILURE,
            });
          }
        } catch (e) {
          handleError(e, appDispatch);
          appDispatch({
            type: "Set_FreezScreen",
            freezScreen: false,
          });
          console.log(e);
          session.completePayment({
            status: ApplePaySession.STATUS_FAILURE,
          });
        }
      } else {
        setAlertMessage({
          open: true,
          message: " Amount is greater than remaining ",
          alertSuccess: false,
        });
        appDispatch({
          type: "Set_FreezScreen",
          freezScreen: false,
        });
      }
    }
  }; // See "Authorizing Payment"

  session.oncancel = (event) => {
    console.log(event);
    console.log("oncancle 1");
    setPLoading(false);
    appDispatch({
      type: "Set_FreezScreen",
      freezScreen: false,
    });
    console.log("oncancle 2");
    session.completePayment({
      status: ApplePaySession.STATUS_FAILURE,
    });
  };
  var begin = session.begin();
  console.log(begin, "begin");
};
